import { IGoal } from "@gtmhub/goals/models";
import { Session } from "@webapp/sessions/models/sessions.model";

export enum JobStatus {
  Pending = "pending",
  InProgress = "in_progress",
  Done = "done",
  ToBeReverted = "to_be_reverted",
  Reverting = "reverting",
  Reverted = "reverted",
}

type ClonedIds = Record<string, string>;

export interface JobId {
  id: string;
}

export interface ICloneJob extends JobId {
  status: JobStatus;
  clonedIds: ClonedIds;
  rootClonedId: string;
  resourceType: CloneOrMoveResourceType;
}

export interface IMoveJob extends JobId {
  status: JobStatus;
  movedIds: ClonedIds;
  rootMovedId: string;
  resourceType: CloneOrMoveResourceType;
}

export interface NotificationInfo {
  targetSessionName?: string;
  targetGoalName?: string;
}

export type MethodType = "clone" | "move";
export type InvokerType = "okr" | "kr";

export enum ActionType {
  Clone = "clone",
  Move = "move",
}

export enum CloneOrMoveResourceType {
  Session = "session",
  KeyResult = "kr",
  Objective = "okr",
}

export interface IGoalCloneSelected {
  session: Session;
  goal: IGoal;
  progress: boolean;
  notifications: boolean;
  duplicateInsight: boolean;
  cloneTasks: boolean;
  cloneChildren: boolean;
}

export interface IGoalMoveSelected {
  session: Session;
  goal: IGoal;
  progress: boolean;
  notifications: boolean;
  duplicateInsight: boolean;
  moveChildren: boolean;
}

export interface IMetricCloneSelected {
  session: Session;
  goal: IGoal;
  progress: boolean;
  notifications: boolean;
  duplicateInsight: boolean;
  sync?: boolean;
}
export interface ResourceRequest {
  type: CloneOrMoveResourceType;
  resourceId: string;
  targetType: CloneOrMoveResourceType;
  targetResourceId: string;
}

export interface MoveResourceRequest extends ResourceRequest {
  moveChildren?: boolean;
  targetSessionId: string;
}
